import { api } from '@/lib/api';

// Aufgaben zum Projekt (pm-api routers/tasks.py, core-Task). Ohne
// `assigned_to` gehört die Aufgabe dem, der sie anlegt; sie steht damit auch
// in seinen Aufgaben im CRM.

export interface AufgabeAnlegen {
  title: string;
  /** YYYY-MM-DD */
  due_date?: string;
}

/** Werte wie TaskStatus in core: open, in_progress, completed, cancelled, blocked. */
export type AufgabeStatus = 'open' | 'in_progress' | 'completed' | 'cancelled' | 'blocked';

export interface Aufgabe {
  id: string;
  title: string;
  description: string | null;
  status: AufgabeStatus | (string & NonNullable<unknown>);
  priority: string;
  project_id: string | null;
  assigned_to: string | null;
  due_date: string | null;
  completed_at: string | null;
  created_at: string;
}

/** Erledigt oder abgebrochen: steht unter „Erledigte“. */
export function istAbgeschlossen(aufgabe: Aufgabe): boolean {
  return aufgabe.status === 'completed' || aufgabe.status === 'cancelled';
}

export const tasksApi = {
  // Alle Aufgaben des Projekts; das Backend sortiert nach Fälligkeit, ohne
  // Datum zuletzt.
  list: async (projectId: string): Promise<Aufgabe[]> => {
    const { data } = await api.get(`/projects/${projectId}/tasks`);
    return data;
  },

  create: async (projectId: string, aufgabe: AufgabeAnlegen): Promise<Aufgabe> => {
    const { data } = await api.post(`/projects/${projectId}/tasks`, aufgabe);
    return data;
  },

  complete: async (taskId: string): Promise<Aufgabe> => {
    const { data } = await api.post(`/tasks/${taskId}/complete`);
    return data;
  },

  /**
   * Zurück auf offen. `POST /tasks/{id}/complete` hat kein Gegenstück, der
   * vorhandene `PUT /tasks/{id}` nimmt dafür den Status (pm-api
   * `update_task`). Ohne diesen Weg war ein Haken endgültig: Die Oberfläche
   * bot nichts an, und das API-Modul kannte nichts.
   *
   * `completed_at` bleibt dabei stehen — das Backend löscht den Zeitstempel
   * nicht, und `TaskUpdate` kennt das Feld nicht. Für die Anzeige ist das ohne
   * Folge: Ob eine Aufgabe erledigt ist, entscheidet der Status
   * (`istAbgeschlossen`), nicht der Zeitstempel.
   */
  reopen: async (taskId: string): Promise<Aufgabe> => {
    const { data } = await api.put(`/tasks/${taskId}`, { status: 'open' });
    return data;
  },
};
